<template>
  <div>
    <h1>
      {{ setName }} Set
      <span>
        {{ set.jpCaption }}・セット
      </span>
    </h1>
    <p class="notices">
      {{ set.notices }}
    </p>
    <div
      id="figures"
      :class="getNumberOfFigures(set.figures)">
        <table
          v-for="(figure, index) in set.figures"
          :key="index">
          <thead>
            <tr>
              <td colspan="2">
                <h3>
                  Figure {{figure.order}}: {{figure.rythmn}}
                </h3>
                  {{figure.summary}}
                <p>
                  {{ getBars(figure) }} bars + 8 bar lead in
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="movement in figure.movements"
              class="movement">
              <td
                :class="movement.type"
                class="bar">
                {{ movement.bar }}
              </td>
              <td
                v-if="!movement.caption"
                :class="movement.type"
                class="summary"
                key="movementWithCaption">
                {{ movement.summary }}
              </td>
              <td
                v-else
                :class="movement.type"
                @click="openMovementCaption('captiondialog', figureIndex, movement.summary, movement.caption, movement.image)"
                class="summary withCaption">
                <md-button class="">{{ movement.summary }}<i class="material-icons">launch</i></md-button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <md-dialog
        md-open-from="#custom"
        md-close-to="#custom"
        @open="onOpen"
        @close="onClose"
        ref="captiondialog">
        <md-dialog-title>
          <img
            :src="'/static/img/movement/' + alert.image"
            v-if="alert.image"
            key="animation"
            class="animation" />
          {{ alert.title }}
        </md-dialog-title>

        <md-dialog-content>
          <!-- {{ alert.contentHtml }} -->
          <ul>
            <li v-if="!Array.isArray(alert.contentHtml)" key="one_sentence">{{ alert.contentHtml }}</li>
            <li v-else v-for="instruction, index in alert.contentHtml" :key="index">{{ instruction }}</li>
          </ul>
        </md-dialog-content>

        <md-dialog-actions>
          <router-link
            class=""
            tag="md-button"
            :to="{ name: 'ReportMovement', params: { setName: setName, figureNumber: alert.figureNumber, movement: alert.title }}">
            誤字脱字を報告する
          </router-link>
          <md-button
            class="md-primary"
            @click="closeDialog('captiondialog')">{{ alert.close }}</md-button>
        </md-dialog-actions>

      </md-dialog>

    <!-- <form novalidate @submit.stop.prevent="openErrorConsole">
      <md-snackbar :md-position="'left center'" ref="snackbar" :md-duration="4000">
        <span>{{ movementsCaption }}</span>
      </md-snackbar>
    </form> -->

    <footer>
      <router-link
        tag="md-button"
        :to="{ name: 'Set', params: { setName: setName }}"
        id="btn-return"
        class="md-raised md-primary">
        戻る / Back
      </router-link>
    </footer>

  </div>
</template>

<script>
import db from '../db'

export default {
  name: 'figures',
  data () {
    return {
      error: null,
      setName: this.$route.params.setName,
      set: {},
      movementsCaption: '',
      alert: {
        title: 'test',
        contentHtml: 'Your post has been deleted!',
        close: '閉じる / Close'
      }
    }
  },
  created () {
    if (this.set === null) {
      this.refreashData()
    }
  },
  watch: {
    '$route': 'refreashData'
  },
  beforeRouteEnter: (to, from, next) => {
    db.ref('/sets/' + to.params.setName).once('value').then(function (sets) {
      next((vm) => {
        vm.set = sets.val()
      })
    })
  },
  methods: {
    refreashData () {
      let self = this
      db.ref('/sets/' + this.$route.params.setName).once('value').then(function (sets) {
        self.set = sets.val()
      })
    },
    getNumberOfFigures: function (figures) {
      if (figures === undefined) {
        return ''
      }
      return 'numberOfFiguresIs' + figures.length.toString()
    },
    getBars: function (figure) {
      let bars = 0
      for (let i in figure.movements) {
        if (figure.movements[i].bar !== '') {
          bars += figure.movements[i].bar
        }
      }
      return bars
    },
    openMovementCaption (ref, figureNumber, title, contentHtml, image) {
      if (!contentHtml) { return }
      this.alert.title = title
      this.alert.contentHtml = contentHtml
      this.alert.figureNumber = figureNumber
      this.alert.image = image
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
      console.log('Opened')
    },
    onClose (type) {
      console.log('Closed', type)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-weight: normal;
}

h1 span {
    display: block;
    margin-top: 16px;
    font-size: 16px;
}

h3 {
  margin: 12px;
}

p {
  margin: 8px;
}

a {
  color: #42b983;
}

.clear {
    clear: both;
}

.md-whiteframe {
  background-color: #fff;
  /*overflow: auto;*/
}

#figures {
  display: inline-flex;
  justify-content: center;
  /*overflow: auto;*/
}

@media screen and (min-width: 0) and (max-width: 480px) {
  /*#figures {
    max-width: 480px;
  }*/
}
@media screen and (min-width: 640px) and (max-width: 819px) {
  /*#figures {
    max-width: 640px;
  }*/
  #figures.numberOfFiguresIs4 {
    justify-content: flex-start;
  }
  #figures.numberOfFiguresIs5 {
    justify-content: flex-start;
  }
  #figures.numberOfFiguresIs6 {
    justify-content: flex-start;
  }
  #figures.numberOfFiguresIs7 {
    justify-content: flex-start;
  }
}
@media screen and (min-width: 820px) and (max-width: 965px) {
  #figures {
    max-width: 820px;
  }
  #figures.numberOfFiguresIs4 {
    justify-content: center;
  }
  #figures.numberOfFiguresIs5 {
    justify-content: flex-start;
  }
  #figures.numberOfFiguresIs6 {
    justify-content: flex-start;
  }
  #figures.numberOfFiguresIs7 {
    justify-content: flex-start;
  }
}
@media screen and (min-width: 966px) and (max-width: 1409px) {
  #figures.numberOfFiguresIs4 {
    justify-content: center;
  }
  #figures.numberOfFiguresIs5 {
    justify-content: center;
  }
  #figures.numberOfFiguresIs6 {
    justify-content: flex-start;
  }
  #figures.numberOfFiguresIs7 {
    justify-content: flex-start;
  }
}
@media screen and (min-width: 1410x) and (max-width: 1566px) {
  #figures {
    max-width: 1245px;
  }
  #figures.numberOfFiguresIs4 {
    justify-content: center;
  }
  #figures.numberOfFiguresIs5 {
    justify-content: center;
  }
  #figures.numberOfFiguresIs6 {
    justify-content: center;
  }
  #figures.numberOfFiguresIs7 {
    justify-content: flex-start;
  }
}

#figures table {
  flex: 1;
  margin-bottom: 24px;
}

.figure {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

section {
  margin-bottom: 24px;
}

table {
  float: left;
}

table.figure {
  float: none;
}

/*http://www.color-hex.com/color-palette/39118*/
tbody {
  white-space: nowrap;
  width: auto;
}

tr {
  height: 30px;
}

td {
  margin: 1px 0;
}

td.bar {
  padding: 4px 4px;
}

td.summary {
  /*width: 220px;*/
  min-width: 160px;
  padding: 4px 16px;
}

td.summary.withCaption {
  padding: 0 16px;
}

td.summary.withCaption .md-button {
  line-height: 22px;
  min-height: 22px;
  margin: 0;
  padding: 4px 0;
  font-weight: bold;
  text-transform: none;
}

td.summary.withCaption .md-button i {
  padding-left: 4px;
  font-size: 18px;
  font-weight: normal;
  vertical-align: middle;
}

td.common {
  background-color: #ddd;
}

td.repeat {
  background-color: #ffb583;
}

td.bar.nested-repeat {
  background-color: #a5c90f;
}

td.summary.nested-repeat {
  background-color: #ffb583;
}

td.bar.call-nested-repeat {
  background-color: #ffb583;
}

td.summary.call-nested-repeat {
  background-color: #ffb583;
}

footer {
  padding-bottom: 48px;
}
#btn-return {
  display: inherit;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// Figures.vue?798e4280